import { backdropAtom, planDestListAtom, selectedOrderListAtom, selectedPlanCarListAtom } from '@/commons/constants';
import { useAtom, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { execModalAtom } from './common/constants';
import styled from 'styled-components';
import InputForm from './inputForm';
import ResultList from '../result/list';
import { Button, Divider, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const MainWrap = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .mainBody{
    flex-grow:1;
    width:100%;
    height:100%;
    overflow: hidden;
  }
`;

const ModalWrap = styled.div`
  position: absolute;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
  width: 95%;
  height: 95%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .head{
    padding: 0.5rem;
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background:rgba(82, 133, 164, 0.87);
    color: #ffffff;
  }
`;

export default function Exec() {
  const [execModal, setExecModal] = useAtom(execModalAtom);
  const setBackdrop = useSetAtom(backdropAtom);
  const setSelectedPlanDestList = useSetAtom(planDestListAtom);
  const setSelectedPlanCarList = useSetAtom(selectedPlanCarListAtom);
  const setSelectedOrderList = useSetAtom(selectedOrderListAtom);
  useEffect(() => {
    setBackdrop(false);
  }, []);
  const handleClose = () => {
    setSelectedOrderList([]);
    setSelectedPlanDestList([]);
    setSelectedPlanCarList([]);
    setExecModal(false);
  };
  return (
    <>
      <MainWrap>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="contained" onClick={() => setExecModal(true)}>
            신규배차
          </Button>
        </div>
        <div className="mainBody">
          <ResultList />
        </div>
      </MainWrap>
      <Modal open={execModal} onClose={handleClose}>
        <ModalWrap>
          <div className="head">
            <Typography variant="h5">신규 배차</Typography>
            <CloseIcon onClick={handleClose} />
          </div>
          <Divider />
          <div style={{ padding: '1rem', width: '100%', height: '100%', overflow: 'hidden' }}>
            <InputForm />
          </div>
        </ModalWrap>
      </Modal>
    </>
  );
}
